import request from '@/utils/request'

export function uploadImage(query) {
  return request({
    url: '/index/account/uploadImage',
    method: 'post',
    data: query
  })
}

export function updateProfile(query) {
  return request({
    url: '/index/account/updateProfile',
    method: 'post',
    params: query
  })
}


